var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 22,
    viewBox: "0 0 28 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.5 4.75L15.2875 11.875C14.9016 12.1168 14.4554 12.245 14 12.245C13.5446 12.245 13.0984 12.1168 12.7125 11.875L1.5 4.75M4 1H24C25.3807 1 26.5 2.11929 26.5 3.5V18.5C26.5 19.8807 25.3807 21 24 21H4C2.61929 21 1.5 19.8807 1.5 18.5V3.5C1.5 2.11929 2.61929 1 4 1Z",
    stroke: "#09090B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.02bea338360e385d02b3ffa8ea26c8e3.svg";
export { ForwardRef as ReactComponent };